export const HpSettingsClientAndSchedulingPage: React.FC = () => {
  return <div>Clients and scheduling</div>;
};
